/*
 * Jira Ticket:
 * rejectd Date: Mon, 20th Apr 2020, 15:01:34 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import gql from 'graphql-tag';

export const rejectSubcontractMutation = gql`
  mutation rejectSubcontract($id: ID!) {
    data: rejectSubcontract(id: $id) {
      id
    }
  }
`;

export default ({ client, params }) => {
  try {
    return client.mutate({
      mutation: rejectSubcontractMutation,
      variables: {
        ...params,
      },
    });
  } catch (e) {
    if (e.graphQLErrors && e.graphQLErrors.length) {
      const [error] = e.graphQLErrors;
      const message = error.message;
      throw new Error(message);
    }
    throw e;
  }
};
